import type { UserData, UserDataInput } from "../api/user";
import omit from "lodash/omit";

export const processUserData = (userData: UserData): UserDataInput => {
  const visibleMetadata = omit(userData.metadata ?? {}, ["email_verified"]);

  return {
    ...visibleMetadata,
    first_name: userData.first_name,
    last_name: userData.last_name,
    email: userData.email,
    phone: userData.phone
  };
};
